import { useState } from 'react'
import SessionsDataGrid from './components/SessionsDataGrid'
import DashboardLayout from '../components/DashboardLayout'
import { enqueueSnackbar, SnackbarProvider } from 'notistack'
import API from '@enums/api'
import useDataSource from '@hooks/useDataSource'

export default function SessionsOverviewPage() {
    const [error, setError] = useState<string | undefined>()

    const dataSource = useDataSource({
        getRows: async ({ paginationModel, sortModel, filterModel }) => {
            const res = await API.overviews.sessions({
                paginationModel,
                sortModel,
                filterModel,
            })

            if (!res.ok) {
                const message = `Failed to get session data: ${res.status} ${res.error.message}`
                setError(message)
                enqueueSnackbar({
                    variant: 'error',
                    message,
                })
                throw new Error(message)
            }

            const { rows, total_rows } = res.value

            return {
                rows,
                rowCount: total_rows,
            }
        },
    })

    if (error) {
        return <DashboardLayout>{error}</DashboardLayout>
    }

    return (
        <DashboardLayout>
            <SessionsDataGrid
                showUser={true}
                enqueueSnackbar={enqueueSnackbar}
                showExport
                {...dataSource}
            />

            <SnackbarProvider
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            />
        </DashboardLayout>
    )
}
